import { Grid } from "@mui/material";

interface FormRowProps {
  children: React.ReactNode;
  gapAfter?: boolean;
  gapBefore?: boolean;
  title?: string;
}

const FormRow = ({ children, gapBefore, gapAfter, title }: FormRowProps) => {
  return (
    <>
      {title && <h3>{title}</h3>}
      <Grid
        paddingLeft={2}
        paddingTop={gapBefore ? 4 : 0}
        paddingBottom={gapAfter ? 4 : 0}
        container
        justifyContent="space-between"
      >
        {children}
      </Grid>
    </>
  );
};

export default FormRow;
